import {Stack} from '@mui/material';
import React from 'react';

import {AlertInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {makeGetWaitingPeriodUrl} from 'main/factories/usecases/private/external-links/remote-waiting-period/waiting-period-factory';
import {useGetEndpointUrl} from 'presentation/hooks';
import {Loading} from 'presentation/components/Loading/Loading';
import Icon from 'presentation/icons';

const {title, description, action} =
	translations['pt-br'].privateFlow.healthCard.cardData.waitingPeriodAlert;

export function WaitingPeriodAlert() {
	const {getLink, isLoading} = useGetEndpointUrl(title);
	const handleOpenLink = () => {
		getLink(makeGetWaitingPeriodUrl);
	};

	return (
		<AlertInfo.Root severity="warning">
			<AlertInfo.Title title={title} />
			<AlertInfo.Description>{description}</AlertInfo.Description>
			<Stack>
				<AlertInfo.Action
					display="flex"
					justifyContent="flex-end"
					mt={1}
					onClick={handleOpenLink}
					disabled={isLoading}
					endIcon={
						isLoading ? (
							<Loading size={20} color="inherit" />
						) : (
							<Icon name="external-link-default" size={20} />
						)
					}>
					{action}
				</AlertInfo.Action>
			</Stack>
		</AlertInfo.Root>
	);
}
